import { useAuth } from "@assetwatch/auth";
import { InlineLink, Stack, Text, Title } from "@assetwatch/ui";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useFeatureFlags } from "../components/LaunchDarkly/useFeatureFlags";
import { canAccessMotionAmplification } from "../lib/access";

export function HomeScreen() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const flags = useFeatureFlags();
  const canViewMotionAmplification = canAccessMotionAmplification({
    flags,
    user,
  });

  return (
    <Stack gap={24}>
      <Text tone="subtle">{t("home.introduction")}</Text>
      {canViewMotionAmplification && (
        <Stack gap={8}>
          <Title size="md">{t("home.availableModalities")}</Title>
          <nav aria-label={t("home.availableModalities")}>
            <Stack gap={4}>
              <InlineLink
                render={
                  <Link className="text-primary" to="/motion-amplification" />
                }
              >
                {t("motionAmplification.pageTitle")}
              </InlineLink>
              <Text tone="subtle">
                {t("home.motionAmplificationDescription")}
              </Text>
            </Stack>
          </nav>
        </Stack>
      )}
    </Stack>
  );
}
